import { environment } from "../../environments/Environment";
import { sessionService } from "../Session/SessionService";

class HTTPService {
  apiBaseURL = process.env.REACT_APP_API_BASE_URL;
  options = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      operatorId: "",
      platformId: "",
    },
  };

  constructor() { }

  get(url, headers = null) {
    let options = { ...this.options };
    options.method = "GET";
    if (headers) {
      options.headers = { ...options.headers, ...headers };
    }
    options.headers = this.addCustomHeaders(options.headers);
    let promise = new Promise((resolve, reject) => {
      fetch(this.apiBaseURL + url, options)
        .then(
          async (successResponse) => {
            let res = await successResponse.json();
            resolve(res);
          },
          async (failureResponse) => {
            console.log("Failed", failureResponse);
            let failRes = await failureResponse.json();
            reject(failRes);
          }
        )
        .catch(async (errorResponse) => {
          console.log("Failed", errorResponse);
          let failRes = await errorResponse.json();
          reject(failRes);
        });
    });
    return promise;
  }

  put(url, data, headers = null) {
    let options = { ...this.options };
    options.method = "PUT";
    options.data = JSON.stringify(data);
    if (headers) {
      options.headers = { ...options.headers, ...headers };
    }
    options.headers = this.addCustomHeaders(options.headers);
    let promise = new Promise((resolve, reject) => {
      fetch(this.apiBaseURL + url, options)
        .then(
          async (successResponse) => {
            let res = await successResponse.json();
            resolve(res);
          },
          async (failureResponse) => {
            console.log("Failed", failureResponse);
            let failRes = await failureResponse.json();
            reject(failRes);
          }
        )
        .catch(async (errorResponse) => {
          console.log("Failed", errorResponse);
          let failRes = await errorResponse.json();
          reject(failRes);
        });
    });
    return promise;
  }

  post(url, data, headers = null) {
    let options = { ...this.options };
    options.method = "POST";
    options.body = JSON.stringify(data);
    if (headers) {
      options.headers = { ...options.headers, ...headers };
    }
    options.headers = this.addCustomHeaders(options.headers);
    let promise = new Promise((resolve, reject) => {
      fetch(this.apiBaseURL + url, {
        headers: this.options.headers,
        method: "POST",
        body: JSON.stringify(data),
      })
        .then(
          async (successResponse) => {
            let res = await successResponse.json();
            resolve(res);
          },
          async (failureResponse) => {
            console.log("Failed", failureResponse);
            let failRes = await failureResponse.json();
            reject(failRes);
          }
        )
        .catch(async (errorResponse) => {
          console.log("Failed", errorResponse);
          let failRes = await errorResponse.json();
          reject(failRes);
        });
    });
    return promise;
  }

  delete(url, data = null, queryParams = null, headers = null) {
    let options = { ...this.options };
    options.method = "DELETE";

    if (data) {
      options.data = JSON.stringify(data);
    }
    if (headers) {
      options.headers = { ...options.headers, ...headers };
    }
    options.headers = this.addCustomHeaders(options.headers);
    let promise = new Promise((resolve, reject) => {
      fetch(this.apiBaseURL + url, options)
        .then(
          async (successResponse) => {
            let res = await successResponse.json();
            resolve(res);
          },
          async (failureResponse) => {
            console.log("Failed", failureResponse);
            let failRes = await failureResponse.json();
            reject(failRes);
          }
        )
        .catch(async (errorResponse) => {
          console.log("Failed", errorResponse);
          let failRes = await errorResponse.json();
          reject(failRes);
        });
    });

    return promise;
  }

  patch() { }

  addCustomHeaders(headers) {
    let userSession = sessionService.getUserSession();
    headers["operatorId"] = userSession.operatorId || "";
    headers["platformId"] = userSession.platformId || "";
    headers["currencyCode"] = userSession.currencyCode || "";
    headers["brand"] = userSession.brand || "";
    return headers;
  }
}

export const httpService = new HTTPService();
